// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__16smS","gfeWrapper":"CalendarEvent_gfeWrapper__1Tp3m"};